import styled from "styled-components";
import { Paper, TextField } from "@material-ui/core";
import { Search, Close } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";

export const Container = styled(Paper)`
  width: 100%;
  height: 40px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  font-size: 12px;
  margin-right: 10px;
`;

export const SearchInput = styled(TextField)``;

export const SearchIcon = styled(Search).attrs({
  fontSize: "default",
})``;

export const CloseIcon = styled(Close).attrs({
  fontSize: "default",
})``;

export const CloseButton = styled(IconButton)`
  width: 35px;
  height: 35px;
`;
